import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyCompetition, Competition } from "../../../../interfaces/competition";
import { deleteCompetition, getCompetitionSingle } from "../../../../services/competition";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminCompetitionDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCompetitionDelete(props: AdminCompetitionDeleteProps) {
    const [competition, setCompetition] = useState<Competition>(emptyCompetition);

    const handleDelete = () => {
        deleteCompetition(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Competition cannot be deleted. Try again later."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getCompetitionSingle(props.id)
            .then(response => {
                setCompetition(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-competition-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_competition") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { competition.id == 0 && 
                    <LoadingSpinner />
                }
                { competition.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_competition_message"
                                values={{
                                    competition_name: competition.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
